<div class="split-form">
  <div class="image-side font-weight-bolder">
    <img src="../../../assets/img/logo-agrama.png" style="width: 250px;height: 300px;">
    <h1 class="font-weight-bolder">Welcome Agaram Selvi Academy</h1>
  </div>
  <div class="form-side">
    <div class="form">
      <h2 class="text-center font-weight-bolder gradient-text mb-3">Sign In</h2>
      <form [formGroup]="loginForm" (submit)="onSubmit()">
        <input type="text" placeholder="User Name" class="form-control mb-3" formControlName="userName" id="userName"
          autocomplete="off"
          [ngClass]="{'is-invalid': loginForm.get('userName')?.invalid && loginForm.get('userName')?.touched,
                                    'is-valid': loginForm.get('userName')?.valid && loginForm.get('userName')?.touched}">

        <div *ngIf="f.userName.touched && f.userName.invalid" class="text-danger small">
          User name is required.
        </div>
        <div class="password-container">
          <input [type]="showPassword ? 'text' : 'password'" placeholder="Password" formControlName="password"
            id="password" class="form-control" autocomplete="off"
            [ngClass]="{'is-invalid': loginForm.get('password')?.invalid && loginForm.get('password')?.touched,
                                    'is-valid': loginForm.get('password')?.valid && loginForm.get('password')?.touched}">
          <i class="bi" [ngClass]="showPassword ? 'bi-eye' : 'bi-eye-slash'" (click)="togglePasswordVisibility()"></i>
        </div>
        <div *ngIf="f.password.touched && f.password.invalid" class="text-danger small mt-1">
          <div *ngIf="f.password.errors?.required">Password is required.</div>
          <div *ngIf="f.password.errors?.minlength">Minimum 6 characters required.</div>
        </div>
        <button type="submit">Login</button>

        <!-- <p class="mt-3 mb-0 text-bold text-center">New to Add Invitation? <a [routerLink]="['/register']"
            class="text-decoration-none">Sign up</a>
        </p> -->
      </form>
    </div>
  </div>
</div>